import { Box, Button, MenuItem, TextField } from '@mui/material';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { createOcpReport } from '../../stores/sensor/sensorStore';

const REPORT_OCCUPANCY_OPTIONS = [
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  '10-15',
  '16-20',
  '21-30',
  '31-40',
  '41-60',
  '61-80',
  '81+',
];

const ReportDeviceModalContent = ({
  userId,
  deviceId,
  occupancyValue,
  commentValue,
  onOccupancyChange,
  onCommentChange,
  onSubmitted,
}) => {
  const dispatch = useDispatch();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async () => {
    const ocp = String(occupancyValue || '').trim();
    if (!ocp) {
      if (onSubmitted) {
        onSubmitted({
          success: false,
          message: 'Please select current occupancy before sending.',
        });
      }
      return;
    }
    if (!Number.isInteger(Number(userId)) || !Number.isInteger(Number(deviceId))) {
      if (onSubmitted) {
        onSubmitted({
          success: false,
          message: 'Failed to save report: missing user or device details.',
        });
      }
      return;
    }

    try {
      setIsSubmitting(true);
      const payload = {
        user_id: Number(userId),
        device_id: Number(deviceId),
        ocp,
        comment: String(commentValue || '').trim() || null,
        report_time: new Date().toISOString(),
        client_timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || 'UTC',
      };
      await dispatch(createOcpReport(payload)).unwrap();
      if (onSubmitted) {
        onSubmitted({
          success: true,
          message: 'Report saved successfully. Thank you!',
        });
      }
    } catch (error) {
      console.error('Failed to create occupancy report:', error);
      if (onSubmitted) {
        onSubmitted({
          success: false,
          message: error?.message || 'Failed to save report. Please try again.',
        });
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Box sx={{ minWidth: { xs: '260px', sm: '360px' }, display: 'grid', gap: 2 }}>
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '.7fr .3fr',
          gap: 1.5,
          alignItems: 'stretch',
        }}>
        <TextField
          select
          fullWidth
          size="small"
          label="Current People Count"
          value={occupancyValue}
          SelectProps={{
            MenuProps: {
              disablePortal: true,
              anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'left',
              },
              transformOrigin: {
                vertical: 'top',
                horizontal: 'left',
              },
              PaperProps: {
                sx: {
                  mt: -1,
                  borderTopLeftRadius: 0,
                  borderTopRightRadius: 0,
                  maxHeight: 400,
                  overflowY: 'auto',
                },
              },
              MenuListProps: {
                sx: { py: 0 },
              },
            },
          }}
          onChange={onOccupancyChange}>
          {REPORT_OCCUPANCY_OPTIONS.map(option => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </TextField>
        <Button
          variant="contained"
          onClick={handleSubmit}
          disabled={isSubmitting}
          sx={{ width: '100%' }}>
          {isSubmitting ? 'Sending...' : 'Send'}
        </Button>
      </Box>
      <TextField
        fullWidth
        multiline
        minRows={3}
        label="Comment"
        value={commentValue}
        onChange={onCommentChange}
      />
    </Box>
  );
};

export default ReportDeviceModalContent;
